import React, { useState } from "react";
// import "react-responsive-modal/styles.css";
import { Form, Modal } from "react-bootstrap";
import Alert from "react-s-alert";
//import Row from "react-bootstrap/Row";
// import { Modal } from "react-responsive-modal";
import { ReusableOnboardingButton } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { PopupIconButtonReusable } from "../../../../reusableComponents/allPopupReusable/allPopupReusableIconButton/PopupIconButtonReusable";
import { PopupActionButton, PopupInsideButton } from "../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import InputNumberFunc from "../../../../../function/InputNumberFunc";
import { NewInputText } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import NewCountDown from "../../../../reusableComponents/allPopupReusable/tableNumberPopup/NewCountDown";

const ExpEditWaitTime = ({ id, onWaitTimeEdit, disabled, ...props }) => {

  const [state, setState] = useState({
    open: false,
    waitTime: "00",
    id: "",
    errors: {}
  })

  const onOpenModal = () => {
    // if (props.orderData === 7 || props.orderData === 8) {
    // Alert.error(
    //   `<h4>You can't perform this action because your order is ${props.orderData === 7
    //     ? "Completed"
    //     : props.orderData === 8
    //       ? "Cancelled"
    //       : ""
    //   }</h4>`,
    //   {
    //     position: "top-right",
    //     effect: "bouncyflip",
    //     beep: true,
    //     html: true,
    //     timeout: 3000,
    //     offset: 35,
    //   }
    // );
    // } else {
      if(!disabled) setState({ ...state, open: true });
    // }
  };

  const onCloseModal = () => {
    setState({ ...state, open: false });
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  const onChange = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    setState({
      ...state,
      [e.target.name]: number,
      errors: {},
    });
  };

  /***************************
   * @DESC Big Button Handler
   ***************************/
  const bigButtonHandler = (e, type) => {
    e.preventDefault();
    setState({
      ...state,
      waitTime: type,
    });
  };


  const onSubmit = () => {
    onWaitTimeEdit(id, state.waitTime);
    onCloseModal();
  }



  const timeOptions = ['00', '10', '15', '20', '25', '30'];

  return (
    <div>
      {props.noDisplay ? (
        <div onClick={onOpenModal}>{props.noDisplay}</div>
      ) : (
        <>
          {props.editButtonStatus === "pendingEdit" ? (
            <PopupActionButton
              buttonText={props.buttonText}
              buttonType="button"
              // buttonClass="yesButton"
              buttonClass="smallsave"
              onClick={onOpenModal}
              buttonImage={props.IconButton}
            />
          ) : props.editButtonStatus === "viewButtonEdit" ? (
            <div className="f14-500 text-red mb-1" onClick={onOpenModal}>
              <NewCountDown waitNew={props?.waitTimeDiff} />
            </div>
          ) : (
            <PopupIconButtonReusable
              buttonClass="editButton"
              buttonType="button"
              titleText="Edit Timer"
              image={require("../../../../../assets/images/superadmin/ordericon/Edit.svg")}
              onClick={onOpenModal}
            />
          )}
        </>
      )}
      <Modal
        show={state.open}
        onHide={onCloseModal}
        centered
        size="md"
        style={{ zIndex: "1061" }}
      >
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f24-700">
            {props.editButtonStatus === "pendingEdit"
              ? "Enter Wait Time"
              : "Edit Wait Time"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <div className="reason-for-cancellation p-0">
            <Form
              noValidate
            >
              <div className="mt-2 mb-3">
                <div className="d-flex justify-content-between align-items-baseline mb-4">
                  <div className="w-75">
                    <div className="d-flex align-items-center">
                      <NewInputText
                        extraClass="mt-4 mb-0"
                        name="waitTime"
                        inputType="number"
                        onChange={onChange}
                        onKeyDown={InputNumberFunc}
                        maxLength="10"
                        value={state.waitTime}
                        labelText="Enter Wait Time"
                        controlClass={"outlined-helperText "}
                      />
                      <p className="minu-section ml-2 mb-0">Mins</p>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="font_20_m">
                  Select one relevant option from below
                </div>
                <div className="font_16_r mt-2 mb-4">
                  Highest value from below will be sent as wait time
                </div>
                <div className="d-flex flex-wrap justify-content-between">
                  {timeOptions.map(time =>
                    <PopupInsideButton
                      buttonClass={
                        state.waitTime === time
                          ? "status-selected-button-box font_20_m sts_sld_btn_box_a mb-4"
                          : "status-selected-button-box font_20_m mb-4"
                      }
                      buttonText={`${time} Mins`}
                      buttonType="button"
                      onClick={(e) => bigButtonHandler(e, time)}
                    />
                  )}
                </div>
              </div>
              <div className="mt-3 d-flex">
                <ReusableOnboardingButton
                  buttonTitle="Cancel Button"
                  buttonClass={
                    "onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                  }
                  buttonText="Cancel"
                  onClick={onCloseModal}
                  buttonType="button"
                />
                <ReusableOnboardingButton
                  buttonTitle="Save Button"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                  buttonText="Save"
                  onClick={onSubmit}
                  buttonType="button"
                />
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ExpEditWaitTime;
